'use client';

import styled from 'styled-components';

export const ScSliderLayoutContent = styled.div`
  background-color: ${({ theme }) => theme.blackColor};
  border-radius: 24px 24px 0px 0px;
  box-shadow:
    0px 0px 10px 8px rgba(0, 0, 0, 0.4),
    0px 0px 20px 8px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 4;
  margin-top: -24px;
`;
